import { create } from 'zustand';
import { getAuthToken, getAuthUser, setAuthToken, setAuthUser, clearAuthToken, clearAuthUser } from '@/services/api/client';
import type { AuthUser } from '@/domain/types';

interface AuthState {
  token: string | null;
  user: AuthUser | null;
  isAuthenticated: boolean;
  isInitialized: boolean;

  setAuth: (token: string, user: AuthUser) => void;
  /**
   * Replaces the cached user without touching the token. Used by the /auth/me
   * refetch so partner capability changes take effect mid-session (FR-053).
   */
  setUser: (user: AuthUser) => void;
  clearAuth: () => void;
  initialize: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  token: null,
  user: null,
  isAuthenticated: false,
  isInitialized: false,

  setAuth: (token: string, user: AuthUser) => {
    setAuthToken(token);
    setAuthUser(user);
    set({ token, user, isAuthenticated: true });
  },

  setUser: (user: AuthUser) => {
    setAuthUser(user);
    set({ user });
  },

  clearAuth: () => {
    clearAuthToken();
    clearAuthUser();
    set({ token: null, user: null, isAuthenticated: false });
  },

  initialize: () => {
    const token = getAuthToken();
    const user = getAuthUser();
    if (token && user) {
      set({ token, user, isAuthenticated: true, isInitialized: true });
    } else {
      set({ isInitialized: true });
    }
  },
}));
